import React, { Suspense } from 'react';
import './LandingPage.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
    useHistory,
    useLocation
} from "react-router-dom";
import Exercise1 from "./pages/Exercise";
import App from "./App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import {
    getBeginner,
    getIntermediate,
    getAdvanced,
    getIntense,
    getProgressiveEasy,
    getProgressiveMedium,
    getProgressiveTough,
    getGeometricPatterns,
} from "./config/exerciseConfig";
import SelfTest from "./pages/SelfTest";
import Dashboard from "./pages/Dashboard";
import AppPolicy from "./pages/AppPolicy";
import Support from "./pages/Support";
import FocusCatcher from "./pages/FocusCatcher";

// Lazy-loaded experimental games
const RockClimber = React.lazy(() => import("./pages/RockClimber"));

function goBack() {
    window.history.back();
}


const LandingPage = () =>
(
    <Router>
        <div>
            <Switch>
                <Redirect exact from="/" to="/welcome" />
                <Route path="/rockClimber">
                    <Suspense fallback={<div style={{color:'#fff',textAlign:'center',marginTop:'40vh',fontSize:'18px'}}>Loading...</div>}>
                        <RockClimber />
                    </Suspense>
                </Route>
                <Route path="/focusCatcher">
                    <FocusCatcher />
                </Route>
                <Route path="/selfTest">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <SelfTest />
                </Route>
                <Route path="/exerciseBeginner">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getBeginner()} difficulty="beginner" />
                </Route>
                <Route path="/exerciseIntermediate">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getIntermediate()} difficulty="intermediate" />
                </Route>
                <Route path="/exerciseAdvanced">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getAdvanced()} difficulty="advanced" />
                </Route>
                <Route path="/exerciseIntense">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getIntense()} difficulty="intense" />
                </Route>
                <Route path="/exerciseProgressiveEasy">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getProgressiveEasy()} difficulty="progressiveEasy" />
                </Route>
                <Route path="/exerciseProgressiveMedium">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getProgressiveMedium()} difficulty="progressiveMedium" />
                </Route>
                <Route path="/exerciseProgressiveTough">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getProgressiveTough()} difficulty="progressiveTough" />
                </Route>
                <Route path="/exerciseGeometricPatterns">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Exercise1 activities={getGeometricPatterns()} difficulty="geometricPatterns" />
                </Route>
                <Route path="/dashboard">
                    <a onClick={goBack} href={"#"} className={"back"}><FontAwesomeIcon icon={faArrowLeft} /></a>
                    <Dashboard />
                </Route>
                <Route path="/policy">
                    <AppPolicy />
                </Route>
                <Route path="/support">
                    <Support />
                </Route>
                <Route path="/welcome"><App /></Route>
            </Switch>
        </div>
    </Router>
);

export default LandingPage;
